const { REACT_APP_API_MODE, REACT_APP_BASE_URL_Dev, REACT_APP_IMAGE_BASE_URL_Dev, REACT_APP_BASE_URL_Production, REACT_APP_IMAGE_BASE_URL_Production } = process.env
let base_url = ''
let image_base_url = ''
if (REACT_APP_API_MODE === "Dev") {
    base_url = REACT_APP_BASE_URL_Dev
    image_base_url = REACT_APP_IMAGE_BASE_URL_Dev
} else if (REACT_APP_API_MODE === "Production") {
    base_url = REACT_APP_BASE_URL_Production
    image_base_url = REACT_APP_IMAGE_BASE_URL_Production
}
module.exports = { base_url, image_base_url }